/* unplugin-vue-components disabled */import { render } from "./QuizSortingQuestion.vue?vue&type=template&id=0747f276&scoped=true&ts=true"
import script from "./QuizSortingQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizSortingQuestion.vue?vue&type=script&lang=ts"

import "./QuizSortingQuestion.vue?vue&type=style&index=0&id=0747f276&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0747f276"]])

export default __exports__